import { Edit, SimpleForm } from 'react-admin';
import { EnterSubmitBlockingSimpleFormContent } from 'src/client/components/forms/form-components';
import { AdvertiserEditToolbar, AdvertiserFormFields, transformAdvertiserInput } from './shared';

export const AdvertiserEdit = () => (
  <Edit mutationMode="pessimistic" transform={transformAdvertiserInput} redirect="list">
    <SimpleForm component={EnterSubmitBlockingSimpleFormContent} toolbar={<AdvertiserEditToolbar />}>
      <AdvertiserFormFields title="Update Advertiser" showAdServerId showExternalPioId />
    </SimpleForm>
  </Edit>
);
